/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

	'use strict';
	
	(function () {
	
	  var accordionButton = document.getElementsByClassName('js-Item-Accordion_Button');
	  //let accordionButtonIcon = document.getElementsByClassName('js-Item-Accordion_Button_Icon');a
	  var accordionBox = document.getElementsByClassName('js-Item-Accordion_Box');
	
	  var _loop = function _loop(i) {
	    accordionButton[i].addEventListener('click', function () {
	      var accordionStatus = accordionBox[i].dataset.status;
	      if (accordionStatus === 'visible') {
	        accordionBox[i].dataset.status = 'hidden';
	        accordionButton[i].dataset.status = 'hidden';
	      } else {
	        accordionBox[i].dataset.status = 'visible';
	        accordionButton[i].dataset.status = 'visible';
	      }
	    }, false);
	  };
	
	  for (var i = 0; i < accordionButton.length; i++) {
	    _loop(i);
	  }
	
	  $("a[href^=#]").on("click", function () {
	    var linkSpeed = 800;
	    var linkHref = $(this).attr("href");
	
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkPosition = linkTarget.offset().top;
	    $("html, body").animate({ scrollTop: linkPosition }, linkSpeed, "swing");
	
	    return false;
	  });
	
	  var topButton = document.getElementById('js-Item-Top_Button');
	
	  window.addEventListener('scroll', function () {
	    if (window.pageYOffset > 100) {
	      topButton.classList.remove('sw-Top-Hidden');
	    } else {
	      topButton.classList.add('sw-Top-Hidden');
	    }
	  }, false);
	
	  $(function () {
	    $('.hit-01 a').click(function () {
	      $('#hit-01').fadeIn();
	    });
	    $('.miss-01 a').click(function () {
	      $('#miss-01').fadeIn();
	    });
	    $('.hit-02 a').click(function () {
	      $('#hit-02').fadeIn();
	    });
	    $('.miss-02 a').click(function () {
	      $('#miss-02').fadeIn();
	    });
	    $('.hit-03 a').click(function () {
	      $('#hit-03').fadeIn();
	    });
	    $('.miss-03 a').click(function () {
	      $('#miss-03').fadeIn();
	    });
	    $('.close').click(function () {
	      $('.idx-Contents_Modal').fadeOut();
	    });
	  });
	
	  // $(function () {
	  //   $(window).on("load",function(){
	  //     $(".idx-Contents_Modal .wrapper").mCustomScrollbar({
	  //       theme:"minimal-dark"
	  //     });
	  //   });
	  // });
	})();

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// common.bundle.js